import {
  type Dispatch,
  type SetStateAction,
  createContext,
  useEffect,
  useState,
} from "react";
import { Outlet } from "react-router";

import { SpinnerLoader } from "components/loader/loader";
import { POOL_ENUM_DISPLAY_MAP, type PoolType } from "consts";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";

import { usePropertyUpdatePool } from "./hooks";
import styles from "./property-update-pool.module.scss";

export type PropertyUpdatePoolContextState = {
  poolType?: PoolType;
  poolFence?: "Yes" | "No";
  fenceFourFeet?: "Yes" | "No";
  fenceLockingGate?: "Yes" | "No";
  divingBoard?: "Yes" | "No";
  slide?: "Yes" | "No";
  filled?: "Yes" | "No";
  poolDecking?: "Yes" | "No";
  poolDeckGateLock?: "Yes" | "No";
  confirmNoPool?: boolean;
  files?: FileList;
};

export const PropertyUpdatePoolContext = createContext<{
  state: PropertyUpdatePoolContextState;
  setState: Dispatch<SetStateAction<PropertyUpdatePoolContextState>>;
}>({ state: {}, setState: () => null });

export const PropertyUpdatePool = () => {
  const { loading } = usePropertyUpdatePool();

  const { formNavigate, state } =
    useMultiStepFormState<PropertyUpdatePoolContextState>(
      PropertyUpdatePoolContext,
    );

  useEffect(() => {
    if (!state?.poolType) {
      formNavigate("./");
    }
  }, [formNavigate, state]);

  if (loading) {
    return (
      <div className={styles.loaderWrapper}>
        <SpinnerLoader />
      </div>
    );
  }

  return <Outlet />;
};

export const PropertyUpdatePoolFlow = () => {
  const { prevPoolType } = usePropertyUpdatePool();
  const [state, setState] = useState<PropertyUpdatePoolContextState>({
    poolType: POOL_ENUM_DISPLAY_MAP[prevPoolType ?? ""],
  });
  return (
    <PropertyUpdatePoolContext.Provider value={{ state, setState }}>
      <PropertyUpdatePool />
    </PropertyUpdatePoolContext.Provider>
  );
};
